// @flow
import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Button, buttonTypes, buttonSizes } from 'moods-react/Button';
import { Pill, pillColours } from 'moods-react/Pill';
import ImageLoader from '../../../common/image-loader/ImageLoaderComponent';
import { envUrl } from '../../../services/environment/EnvironmentService';
import messages from '../../../../data/accessories';

import './Tile.scss';

export type Props = {
  title: string,
  description: string,
  price: string,
  discountedPrice: string,
  imageUrl: string,
  hoverButtonText: string,
  itemUrl: string,
  history: Object,
  isCustomisable: boolean,
};

type Context = {
  intl: Object,
};

const Tile = (
  { title, description, price, discountedPrice, imageUrl, hoverButtonText, itemUrl, history, isCustomisable }: Props,
  { intl }: Context,
) => {
  const onButtonClick = () => {
    history.push(envUrl(itemUrl));
  };

  return (
    <div className="accessories-tile u-paddingBottom-m u-1/1@small u-1/2@medium u-1/3@large">
      <a className="accessories-tile__img" href={envUrl(itemUrl)}>
        <ImageLoader image={imageUrl} altText={title} type="square" />
        {isCustomisable && (
          <div className="accessories-tile__customisable-pill" data-customisable-pill>
            <Pill colour={pillColours.BLUEBERGINE}>{intl.formatMessage(messages.customisablePillText)}</Pill>
          </div>
        )}
        <div className="accessories-tile__hover u-display-flex@medium u-justifyContent-center">
          <Button
            className="accessories-tile__button"
            type={buttonTypes.GHOST_LIGHT}
            size={buttonSizes.LARGE}
            onClick={onButtonClick}
          >
            {hoverButtonText}
          </Button>
        </div>
      </a>
      <div className="accessories-tile__text-container">
        <div className="accessories-tile__title u-fontFamily-primaryMedium u-fontSize-l u-paddingTop-xxxs">{title}</div>
        <div className="accessories-tile__description u-fontFamily-secondary u-fontSize-s u-paddingTop-xxxs">
          {description}
        </div>
        <div className="u-fontFamily-secondaryMedium u-paddingTop-s u-display-flex u-justifyContent-spaceBetween">
          <div className="u-flex-grow-1">
            <span className="accessories-tile__price u-fontSize-xl">{discountedPrice || price}</span>
            {discountedPrice && (
              <span className="accessories-tile__discounted-price u-fontSize-l u-marginLeft-xs">{price}</span>
            )}
          </div>
          <Button
            className="u-width-auto u-display-none@medium"
            type={buttonTypes.STANDALONE_WHITE}
            size={buttonSizes.SMALL}
            onClick={onButtonClick}
          >
            {hoverButtonText}
          </Button>
        </div>
      </div>
    </div>
  );
};

Tile.displayName = 'Tile';
Tile.contextTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }),
};

export default withRouter(Tile);
